import React, { useEffect, useState } from "react";
import { fetch } from "../utils/api";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Archive } from "../components/archive";
import { Link } from "react-router-dom";
import { StaticKv } from "../components/StaticKv";
import dayjs from "dayjs";
import "../assets/styles/column.scss";

export const News = () => {
  const [news, setNews] = useState<[]>();

  useEffect(() => {
    (async () => {
      try {
        const news = await fetch({
          category: "news",
        });
        if (news.data) setNews(news.data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <div className="page-column">
      <Header>
        <StaticKv title="news" />
      </Header>
      {news && news.length ? (
        <div className="article-wrapper">
          <Archive data={news} type={"news"} />
          <div className="article-list">
            <ul>
              <p className="new">新着</p>
              {news
                ? (news as []).map((item: any, index) => {
                    return (
                      <li key={index}>
                        <Link to={`/news/${item.id}`}>
                          <span className="date">
                            {dayjs(item.date).format("YYYY.MM.DD")}
                          </span>
                          <span>{item.title.rendered}</span>
                        </Link>
                      </li>
                    );
                  })
                : ""}
            </ul>
          </div>
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            margin: "100px auto",
            fontSize: "16px",
          }}
        >
          お知らせの投稿がありません
        </div>
      )}
      <Footer />
    </div>
  );
};
